module.exports = __webpack_public_path__ + "img/ex117.6cc80cce.png";